export const environment = {
  production: true,
  baseAPIUrl: "https://gateway.hala.com",
  bnplOnboardingBaseUrl: "https://gateway.hala.com/bnpl-onboarding/api/v1/",
  // usersGatewayBaseURL: 'https://gateway.hala.com/web/userEntity',
  // gatewayBaseURL: 'https://gateway.hala.com',
  loginBaseURL: 'https://gateway.hala.com/accounts',
  growthbookAPIKey: "sdk-n8j061kLTy0XCicC",
  payLaterOrderBaseUrl: "https://gateway.hala.com/pay-later-orders/api/v1/",
  baseOpenApiUrl: 'https://api.hala.com',

  variables: {
    login: {
      client_id: "supplier_api",
      client_secret: "67409843-fa92-34a8-14a4-7697dc4a7833",
      device_uuid: "5e585b0884d2b148",
      push_id: "sadfasd-adsfasd",
      grantType: "supplier_mobile",
      scope: "scope_supplier_gw_pin offline_access scope_payments_gw_api scope_user_gw_api suppliers"
    },
    ccToken: {
      grant_type: "client_credentials",
      client_id: "supplier_web_onboarding",
      client_secret: "38ec24e1-8429-95e3-4ace-ebd0360c6ea9",
      scope: "supplier_onboarding_web"
    }
  },

  gib: {
    cid: 'gib-w-hala-b-suppliers',
    backUrl: '//api.hala.com/api/fl',
  }
};
